import { render, staticRenderFns } from "./Cookies-de.vue?vue&type=template&id=37c0ca62&"
import script from "./Cookies-de.vue?vue&type=script&lang=js&"
export * from "./Cookies-de.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Markomat-Client\\eLpass\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c0ca62')) {
      api.createRecord('37c0ca62', component.options)
    } else {
      api.reload('37c0ca62', component.options)
    }
    module.hot.accept("./Cookies-de.vue?vue&type=template&id=37c0ca62&", function () {
      api.rerender('37c0ca62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cookies/Cookies-de.vue"
export default component.exports